export const sentryConfig = {
  enabled: true,
  dsn:
    "https://60cbe1b9d69de87983246622b62e34f7@o4511914962255872.ingest.de.sentry.io/4512043707662416",
  tracesSampleRate: 0,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
  ],
};
